import { Component } from '@angular/core';

@Component({
  selector: 'app-designer-portal',
  templateUrl: './designer-portal.component.html',
  styleUrls: ['./designer-portal.component.scss'],
  standalone: false,
})
export class DesignerPortalComponent {}
